// extracted by css-extract-rspack-plugin
export default {"paragraph":"content-editor-plugin-paragraph-Paragraph-paragraph-978bb4b6"};